export const ACCOUNT_TYPE_TRANSLATION_KEYS = {
  1: "applications.trading",
  2: "applications.digital",
};
